<template>
  <div>
    <layout>
      <Search
        slot="header-bar"
        placeholder="请输入关键字或扫一扫码模糊匹配"
        v-model="searchInput"
        @search="deviceSearch"
      >
        <div slot="left-icon">
          <div
            style="display: flex;width: 100%;justify-content: center;align-item: center"
          >
            <span @click="openSearchPanel">高级</span>
            <i
              class="van-icon van-icon-arrow-down"
              style="margin-left:5px;margin-right:5px;"
            ></i>
          </div>
        </div>
        <WeChatIcon slot="right-icon" name="scan" @click="qrScan" />
      </Search>
      <div class="notice-wrap">
        <div slot="show-bar" class="notice-content">
          <div class="notice-body">
            <div
              class="notice-item"
              style=" color: #1890ff;"
              @click="searchAllState"
            >
              <span>全部</span>
              <span>{{ deviceStateCount.total }}</span>
            </div>
            <div
              class="notice-item"
              style="color: #51c332 ;"
              @click="searchNormalState"
            >
              <span>正常</span>
              <span>{{ deviceStateCount.normalTotal }}</span>
            </div>
            <div
              class="notice-item"
              style="color: #f5222d;"
              @click="searchAlarmState"
            >
              <span>告警</span>
              <span>{{ deviceStateCount.alarmTotal }}</span>
            </div>
            <div
              class="notice-item"
              style="color: #faad14;"
              @click="searchLoseState"
            >
              <span>失联</span>
              <span>{{ deviceStateCount.loseTotal }}</span>
            </div>
            <div
              class="notice-item"
              style="color: #7e7e7e;"
              @click="searchOfflineState"
            >
              <span>离线</span>
              <span>{{ deviceStateCount.offlineTotal }}</span>
            </div>
            <div
              class="notice-item"
              style="color: #3598dc;"
              @click="searchNotState"
            >
              <span>未激活</span>
              <span>{{ deviceStateCount.notActiveTotal }}</span>
            </div>
          </div>
        </div>
      </div>
      <PullRefresh v-model="isReFresh" @refresh="onRefresh">
        <List
          style="padding: 5px 12px"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          loading-text="拼命加载中..."
          @load="onLoad"
          :offset="50"
          :immediate-check="true"
        >
          <DeviceItem
            v-for="item in deviceList"
            :key="item.id"
            :device="item"
          />
        </List>
      </PullRefresh>
    </layout>
    <Popup v-model="searchPanel" position="top">
      <Field
        v-model="sn"
        label="设备编号"
        clearable
        placeholder="请输入设备编号或扫一扫"
      >
        <WeChatIcon slot="right-icon" name="scan" @click="qrScan" />
      </Field>
      <Field
        v-model="deviceStateName"
        label="设备状态"
        readonly
        clearable
        placeholder="请选择设备状态"
        right-icon="arrow-down"
        @click="deviceStatePanel = true"
      />
      <Field
        v-model="titles.productName"
        label="产品类型"
        readonly
        clearable
        placeholder="请选择产品类型"
        right-icon="arrow-down"
        @click="selectProduct()"
      />
      <Field
        v-model="titles.areaName"
        label="所属区域"
        readonly
        clearable
        placeholder="请选择所属区域"
        right-icon="arrow-down"
        @click="areaPanel = true"
      />
      <Field
        v-model="titles.unitName"
        label="所在单位"
        readonly
        clearable
        placeholder="请选择所在单位"
        right-icon="arrow-down"
        @click="unitPanel = true"
      />
      <Button
        type="info"
        block
        style="width: 90% ; margin: 10px auto;"
        @click="onRefresh"
        >查询</Button
      >
    </Popup>
    <pf code="DEVICE_ADD" v-if="!home">
      <Icon
        name="plus"
        size="35px"
        color="#fff"
        @click="$router.push('/device/install')"
        class="float-btn-add"
      />
    </pf>
    <SelectPanel
      :data="deviceStateList"
      :show="deviceStatePanel"
      type="deviceState"
      @cancel="deviceStatePanel = false"
      @ok="onStateOk"
    />
    <SelectTreePopup
      :show="unitPanel"
      :defaultSelected="
        titles.unitId ? { id: titles.unitId, name: titles.unitName } : {}
      "
      :treeData="unitTree"
      :defaultTitle="titles.unitName || '选择单位'"
      @ok="onUnitOk"
      @cancel="unitPanel = false"
    />
    <SelectTreePopup
      :show="areaPanel"
      :defaultSelected="
        titles.areaId ? { id: titles.areaId, name: titles.areaName } : {}
      "
      :treeData="areaTree"
      :defaultTitle="titles.areaName || '选择区域'"
      @ok="onAreaOk"
      @cancel="areaPanel = false"
    />
    <SelectProductPopup
      :products="productList"
      :show="productPanel"
      :showAll="true"
      @ok="onOkProduct"
      @cancel="productPanel = false"
    />
  </div>
</template>

<script>
import { Button, Field, Icon, List, Popup, PullRefresh, Search } from "vant";
import DeviceItem from "./components/DeviceItem";
import SelectPanel from "@/components/SelectPanel";
import WeChatIcon from "@/components/Icon/WeChatIcon";
import SelectTreePopup from "@/components/SelectPopup/SelectTreePopup";
import SelectProductPopup from "@/components/SelectPopup/SelectProductPopup";
import wx from "weixin-js-sdk";
import { mapGetters } from "vuex";

export default {
  components: {
    WeChatIcon,
    Search,
    List,
    DeviceItem,
    Popup,
    Field,
    Button,
    Icon,
    SelectPanel,
    PullRefresh,
    SelectProductPopup,
    SelectTreePopup,
  },
  props: {
    home: { type: Boolean, default: false },
  },
  data() {
    return {
      sn: null,
      isReFresh: false,
      finished: false,
      searchInput: null,
      loading: false,
      searchPanel: false,
      unitPanel: false,
      areaPanel: false,
      SelectPanel: false,
      deviceStatePanel: false,
      deviceList: [],
      productPanel: false,
      deviceStateName: "全部",
      deviceState: null,
      titles: {
        productName: "所有产品",
        unitName: "所在单位",
        areaName: "所有区域",
        productId: null,
        unitId: null,
        areaId: null,
      },
      deviceStateList: [
        { value: "All", text: "全部" },
        { value: "Normal", text: "正常" },
        { value: "Alarm", text: "告警" },
        { value: "Offline", text: "离线" },
        { value: "Lose", text: "失联" },
        { value: "NotActive", text: "未激活" },
      ],
      deviceStateCount: {},
    };
  },
  computed: {
    ...mapGetters({
      unitTree: "global/unitTree",
      areaTree: "global/areaTree",
      productList: "global/productList",
    }),
  },
  created() {
    const { unitOrOrgan } = this.$default;
    this.titles.unitName = unitOrOrgan.name;
    this.titles.unitId = unitOrOrgan.id;
  },
  mounted() {
    this.getDeviceState();
  },
  methods: {
    onUnitOk(data) {
      this.unitPanel = false;
      this.titles.unitId = data.id;
      this.titles.unitName = data.name;
    },
    onAreaOk(data) {
      this.areaPanel = false;
      this.titles.areaId = data.id;
      this.titles.areaName = data.name;
    },
    getDeviceState() {
      this.$http.tokiot.device
        .total({
          sn: this.sn,
          deviceState: this.deviceState,
          fullText: this.searchInput,
          areaId: this.titles.areaId,
          productId: this.titles.productId,
          unitId: this.titles.unitId,
        })
        .then((res) => {
          if (res) {
            this.deviceStateCount = res;
          }
        });
    },
    qrScan() {
      const This = this;
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function(res) {
          let resultStr = res.resultStr;
          let index = resultStr.indexOf(`CODE_128,`);
          if (index === -1) {
            This.searchInput = resultStr;
            This.onRefresh();
          } else {
            let len = resultStr.length;
            This.searchInput = resultStr.slice(index + 9, len - 1);
            This.onRefresh();
          }
        },
      });
    },
    openSearchPanel() {
      this.searchPanel = true;
    },

    onStateOk(data) {
      this.deviceStateName = data.text;
      if (data.value === "All") this.deviceState = null;
      else this.deviceState = data.value;
      this.deviceStatePanel = false;
    },
    onLoad(isPullRefresh) {
      if (this.deviceState == "All") {
        this.deviceState = " ";
      }
      this.$http.tokiot.device
        .list({
          sn: this.sn,
          deviceState: this.deviceState,
          fullText: this.searchInput,
          areaId: this.titles.areaId,
          productId: this.titles.productId,
          unitId: this.titles.unitId,
          size: 20,
          page: Math.ceil(this.deviceList.length / 20 + 1),
          getUnitGroup: true,
        })
        .then((res) => {
          if (res) {
            this.deviceList.push(...res.rows);
            this.loading = false;
            if (isPullRefresh) this.isReFresh = false;
            // 数据全部加载完成
            if (this.deviceList.length >= res.total) {
              this.finished = true;
            }
          }
        });
    },
    onRefresh() {
      this.searchPanel = false;
      this.isReFresh = true;
      this.deviceList = [];
      this.onLoad(true);
      this.getDeviceState();
    },
    deviceSearch() {
      this.deviceList = [];
      this.onLoad();
    },
    selectProduct() {
      this.productPanel = true;
    },
    onCancel() {
      this.productPanel = false;
    },
    onOkProduct(product) {
      this.titles.productId = product.id;
      this.titles.productName = product.productName;
      this.productPanel = false;
    },
    onOkDeviceState(data) {
      if (data) {
        this.deviceState = data.value;
        this.deviceStateName = data.text;
      }
      this.deviceStatePanel = !this.deviceStatePanel;
    },
    searchAllState() {
      this.deviceState = " ";
      this.onRefresh();
    },
    searchNormalState() {
      this.deviceState = "Normal";
      this.onRefresh();
    },
    searchAlarmState() {
      this.deviceState = "Alarm";
      this.onRefresh();
    },
    searchLoseState() {
      this.deviceState = "Lose";
      this.onRefresh();
    },
    searchOfflineState() {
      this.deviceState = "Offline";
      this.onRefresh();
    },
    searchNotState() {
      this.deviceState = "NotActive";
      this.onRefresh();
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped>
.float-btn-add {
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 28px;
  right: 20px;
  z-index: 999;
  background: #1988fa;
  border-radius: 50%;
  /*box-shadow: 3px 3px 5px rgb(226, 225, 225);*/
}

.notice-wrap {
  width: 100%;
  height: 37px;
  box-sizing: border-box;
  border-bottom: 1px solid #f2f2f2;
}

.notice-content {
  position: fixed;
  background-color: #fff;
  z-index: 999;
  width: 100%;
}

.notice-body {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}

.notice-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  line-height: 15px;
  padding: 3px 0;
}
</style>
